import React from "react";
import "../../Modal.css";
import "../ModalUpdatePin.css"
import {UpdatePinStep2} from "../../../../pages/dashboard/account/UpdatePin/components/UpdatePinStep2";

export const ModalUpdatePinStep2 = ({isOpen, pin}) => {
  return (
    <UpdatePinStep2 isOpen={isOpen} pin={pin}/>
  )
}